"use strict";
// @ts-ignore
try {
    self['workbox:background-sync:6.5.0'] && _();
}
catch (e) { }
